import React from 'react';
import styled from 'styled-components';

import LocalizedNumber from 'common/components/LocalizedNumber';

import { ZERO_DECIMAL_CURRENCIES } from '../../common/utils/currencyDecimals';

type Props = {
  amount: number;
  currency: Currency;
  numberFormatOptions?: Intl.NumberFormatOptions;
};

const Root = styled.span`
  white-space: nowrap;
`;

const getDecimalAmount = (currency: Currency) => {
  if (ZERO_DECIMAL_CURRENCIES.includes(currency)) {
    return 0;
  }
  return 2;
};

const LocalizedMonetaryAmount = ({ amount, currency, numberFormatOptions = {} }: Props) => {
  const decimalAmount = getDecimalAmount(currency);
  return (
    <Root>
      <LocalizedNumber
        value={amount}
        options={{
          maximumFractionDigits: decimalAmount,
          minimumFractionDigits: decimalAmount,
          ...numberFormatOptions,
          style: 'currency',
          currency,
          currencyDisplay: 'symbol',
        }}
      />
    </Root>
  );
};

export default LocalizedMonetaryAmount;
